import axios from "axios";


export const httpPost = (url: string, data?: any) => {

    return axios.post(url, data, {
        headers: {
            Authorization: `${sessionStorage.getItem("SOPOtoken")}`
        }
    });
}

export const httpPostDownloadFile = (url: string, data?: any) => {

    return axios.post(url, data, {
        headers: {
            Authorization: `${sessionStorage.getItem("SOPOtoken")}`
        },
        responseType: 'blob'
    });
}

export const httpPostMultipart = (url: string, data?: any, onUploadProgressHandler?: any) => {

    return axios.post(url, data, {
        headers: {
            Authorization: `${sessionStorage.getItem("SOPOtoken")}`,
            "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (ProgressEvent) => {
            onUploadProgressHandler(ProgressEvent)
        }
    });
}

export const httpGet = (url: string) => {

    return axios.get(url, {
        headers: {
            Authorization: `${sessionStorage.getItem("SOPOtoken")}`
        }
    });
}

export const httpDelete = (url: string, data?: any) => {

    return axios.delete(url, {
        headers: {
            Authorization: `${sessionStorage.getItem("SOPOtoken")}`
        },
        data: data
    });
}

export const httpGetOuter = (url: string) => {

    return axios.head(url, {
        headers: {
            
        },
        withCredentials: false
    });
}